export function getStoredLang() {
  return localStorage.getItem('lang') ?? 'en-US';
}
export function setStoredLang(lang: string | undefined) {
  localStorage.setItem('lang', lang ?? 'en-US');
}
